export default __webpack_public_path__ + "static/media/DSC_0576.57824b7a.webp";